import { Card } from "@certn/cascadia-react";
import { useEffect, useRef } from "react";

import { IdentityVerification } from "../IdentityVerification";

const HIDE_CHAT_WIDGET = `
  iframe[title*="chat" i],
  iframe[title*="widget" i],
  iframe[title*="launcher" i],
  iframe[title*="messaging" i],
  iframe[title*="zendesk" i],
  iframe[id*="launcher"],
  div[class*="zEWidget"],
  div[id*="zendesk"],
  #launcher,
  #webWidget {
    display: none !important;
  }
`;

function useLockAncestorScroll(ref: React.RefObject<HTMLElement | null>) {
  useEffect(() => {
    if (!ref.current) return;

    document.documentElement.classList.add("idv-scroll-lock");

    const lockedAncestors: HTMLElement[] = [];
    let el = ref.current.parentElement;
    while (el && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      const isScrollContainer =
        style.overflowY === "auto" || style.overflowY === "scroll";
      if (!isScrollContainer && style.overflow === "hidden") {
        lockedAncestors.push(el);
      }
      el = el.parentElement;
    }

    const resetScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.scrollTop !== 0) {
        target.scrollTop = 0;
      }
      if (target.scrollLeft !== 0) {
        target.scrollLeft = 0;
      }
    };

    lockedAncestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", resetScroll);
    });

    const resetWindowScroll = () => {
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };
    window.addEventListener("scroll", resetWindowScroll);

    return () => {
      document.documentElement.classList.remove("idv-scroll-lock");
      lockedAncestors.forEach((ancestor) => {
        ancestor.removeEventListener("scroll", resetScroll);
      });
      window.removeEventListener("scroll", resetWindowScroll);
    };
  }, [ref]);
}

interface Props {
  caseId: string | undefined;
  hasNotManuallyVerified: boolean | undefined;
  updateTabAndCaseDetails: () => void;
}
export function IdentityVerificationTab({
  caseId,
  hasNotManuallyVerified,
  updateTabAndCaseDetails,
}: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  useLockAncestorScroll(containerRef);

  return (
    <div ref={containerRef}>
      <style>{HIDE_CHAT_WIDGET}</style>
      <Card testID="manual-idv" type="large" responsive>
        <IdentityVerification
          caseId={caseId || ""}
          hasNotManuallyVerified={hasNotManuallyVerified}
          updateTabAndCaseDetails={updateTabAndCaseDetails}
        />
      </Card>
    </div>
  );
}
